export async function getCountryCode(): Promise<string> {
    if (process.env.PUBLIC_INSTANCE === 'mimas') {
        await onOptanonScriptLoaded();
        return window['Optanon']?.getGeolocationData?.()?.country ?? '';
    } else {
        throw new Error('No country code available in this instance');
    }
}

function onOptanonScriptLoaded(): Promise<void> {
    return new Promise((resolve) => {
        const script = document.getElementById('optanon-script-id') as HTMLScriptElement | null;
        if (!script) {
            resolve(); // Resolve anyway to avoid hanging
            return;
        }
        if (window['Optanon']?.getGeolocationData) {
            resolve();
        } else {
            script.addEventListener('load', () => resolve(), { once: true });
        }
    });
}
